{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "දින {amount} ක් නොමිලයේ",
    "{amount} off": "{amount} ක වට්ටමක්",
    "{amount} off for first {number} months.": "පළමු මාස {number} සඳහා {amount} ක වට්ටමක්",
    "{amount} off for first {period}.": "පළමු {period} සඳහා {amount} ක වට්ටමක්",
    "{amount} off forever.": "හැමදාටම {amount} ක වට්ටමක්",
    "{discount}% discount": "{discount}% ක වට්ටමක්",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} වෙත තවදුරටත් {newsletterName} newsletter නොලැබෙනු ඇත.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "ඔබගේ comments සඳහා කිසිවෙකු reply කළ විට {memberEmail} වෙත තවදුරටත් email මඟින් දැනුම්දීමක් නොකෙරෙනු ඇත.",
    "{memberEmail} will no longer receive this newsletter.": "මෙම newsletter එක {memberEmail} වෙත තවදුරටත් නොලැබෙනු ඇත.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "දින {trialDays} ක් දක්වා නොමිලේ",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "ගිණුම",
    "Account details updated successfully": "",
    "Account settings": "ගිණුම් සැකසුම්",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "නොමිලයේ ලබාදෙන අත්හදාබැලීමේ කාලය අවසන් වූ පසුව, ඔබ තෝරාගන්නා ලද tier එක අනුව එහි සාමාන්\u200dයය මිල ගණන් අය වනු ඇත. ඊට පෙර ඕනෑම අවස්ථාවක මෙය අවලංගු කිරීමට ඔබට හැකියාව ඇත.",
    "Already a member?": "දැනටමත් සාමාජිකයෙක්ද?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "එම උත්සාහය අසාර්ථක විය. තව ටික වේලාවකින් නැවත උත්සාහ කරන්න, මෙම ගැටළුව තවදුරටත් පවතින්නේ නම්, <a>සහායක අංශය සම්බන්ධ කරගන්න</a>.",
    "Back": "ආපසු",
    "Back to Log in": "නැවත log in වීම සඳහා",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Cancel anytime.": "ඕනෑම අවස්ථාවකදී අවලංගු කළ හැක.",
    "Cancel subscription": "Subscription එක අවලංගු කරන්න",
    "Canceled": "",
    "Cancellation reason": "අවලංගු කිරිමට හේතුව",
    "Change": "වෙනස් කරන්න",
    "Change plan": "",
    "Check spam & promotions folders": "Spam සහ promotions folders පරීක්ෂා කරන්න",
    "Check with your mail provider": "ඔබගේ email සේවා සපයන්නා සමඟින් පරීක්ෂා කර බලන්න",
    "Check your inbox to verify email update": "",
    "Choose": "තෝරන්න",
    "Choose a different plan": "වෙනත් plan එකක් තෝරන්න",
    "Choose a plan": "",
    "Choose your newsletters": "ඔබගේ newsletter වර්ගය තෝරන්න",
    "Click here to retry": "නැවත උත්සාහ කිරීම සඳහා මෙහි click කරන්න",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "වසන්න",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "ප්\u200dරතිචාර",
    "Complimentary": "ස්තුතිපූර්වක",
    "Confirm": "තහවුරු කරන්න",
    "Confirm cancellation": "අවලංගු කිරීම තහවුරු කරන්න",
    "Confirm subscription": "subscribe කිරීම තහවුරු කරන්න",
    "Contact support": "සහායක අංශය සම්බන්ධ කරගන්න",
    "Continue": "ඉදිරියට යන්න",
    "Continue subscription": "Subscription එක පවත්වාගෙන යන්න",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Sign in වීමට නොහැකි විය. Login link එක කල් ඉකුත් වී ඇත.",
    "Could not update email! Invalid link.": "Email ලිපිනය update කළ නොහැකි විය. වැරදි link එකකි.",
    "Create a new contact": "අලුත් contact එකක් නිර්මාණය කරන්න",
    "Current plan": "දැනට පවතින plan එක",
    "Delete account": "ගිණුම Delete කරන්න",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "මෙය සිදු කිරීමට අදහස් නොකලේ ද? <button>මේ හරහා</button> ඔබගේ preferences manage කරගන්න.",
    "Don't have an account?": "ගිණුමක් නොමැතිද?",
    "Edit": "Edit කරන්න",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email newsletter": "Email newsletter",
    "Email newsletter settings updated": "",
    "Email preferences": "Email preferences",
    "Email preferences updated.": "",
    "Emails": "ඊමේල්",
    "Emails disabled": "Emails නවත්වා ඇත",
    "Ends {offerEndDate}": "{offerEndDate} දී අවසන් වනු ඇත",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Error එකක්",
    "Expires {expiryDate}": "{expiryDate} දින අවසන් වෙයි",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "හැමදාටම",
    "Free Trial – Ends {trialEnd}": "අත්හදාබැලීමේ කාලසීමාව {trialEnd} දින අවසන් වෙයි",
    "Get help": "සහාය ලබාගන්න",
    "Get in touch for help": "සහාය ලබාගැනීම සඳහා සම්බන්ධ වෙන්න",
    "Get notified when someone replies to your comment": "ඔබේ ප්\u200dරතිචාරයට යම් අයෙකු පිළිතුරු දුන් විට දැනුම් දෙන්න",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "මෙම post එකට ඔබේ අදහස එක් කරන්න",
    "Help! I'm not receiving emails": "සහාය අවශ්\u200dයයයි! මට emails ලැබෙන්නේ නැහැ.",
    "Here are a few other sites you may enjoy.": "ඔබට රසවිඳිය හැකි තවත් වෙබ් අඩවි කිහිපයක් මෙන්න.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Newsletter එකක් spam ලෙස flag වුවහොත්, එම email ලිපිනයට emails ලැබීම ස්ව්\u200dයංක්\u200dරීයවම අක්\u200dරීය කිරීම හරහා ඔබට අනව්\u200dයශ්\u200dයය messages ලැබීම නතර වන බව සහතික කෙරෙනු ඇත.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Spam සඳහා කළ පැමිණිල්ල අත්වැරදීමකින් සිදු වූවක් හෝ, ඔබ නැවතත් emails ලබාගැනීමට කැමැත්තෙන් සිටින්නේ නම්, පෙර screen එකේ ඇති button එක හරහා emails වලට නැවත subscribe කිරීමේ හැකියාව ඇත.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "ඔබගේ subscription එක මෙම මොහොතේ cancel කළහොත්, {periodEnd} දක්වා ඔබ\u200dගේ access නොවෙනස්ව පවතිනු ඇත.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "ඔබ ව්\u200dයාපාරික හෝ රාජ්\u200dයය email ලිපිනයක් භාවිතා කරන්නේ නම්, {senderEmail} ලිපිනයෙන් එන emails allow කරන ලෙස ඔබගේ IT department එකට දැනුම් දීමට කටයුතු කරන්න.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "වෙබ් අඩවියට පිවිසීම සඳහා link එකක් ඔබගේ email ලිපිනය වෙත යවා ඇත. එය විනාඩි 3ක් ඇතුළත නොපැමිණියේ නම් spam ෆෝල්ඩරය පරීක්ෂා කරන්න.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "ඔබ නැවත emails ලබාගැනීමට කැමති නම්, වඩාත්ම සුදුසු මීළඟ පියවර වන්නේ \u200dඔබ භාවිතා කරන email ලිපිනයෙහි යම්කිසි ගැටළුවක් ඇත්දැයි පරීක්ෂා කිරීමෙන් අනතුරුව, පෙර screen එක හරහා resubscribe මත click කිරීමයි.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "ඔබ subscribe කළ newsletters ඔබට නොලැබෙන්නේ නම්, මේ දේවල් පරීක්ෂා කර බලන්න.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "මෙහි සඳහන් සියළුම දේ පරීක්ෂා කිරීමෙන් අනතුරුවත් ඔබට emails නොලැබෙන්නේ නම්, {supportAddress} සම්බන්ධ කරගනිමින් සහාය ඉල්ලා සිටින්න.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Newsletter එකක් යැවීමේ අවස්ථාවකදී permanent failure එකක් වාර්ථා වුවහොත්, මෙම ගිණුමෙහි emails අක්\u200dරීය කෙරෙනු ඇත.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "ඔබගේ email client එකෙහි contact list එකට {senderEmail} ලිපිනය add කරගන්න. මෙම ලිපිනය හරහා ලැබෙන emails විශ්වාසදායී බව මේ හරහා ඔබගේ emailසේවා සපයන්නාට සංඥා කෙරෙනු ඇත.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "මෙවැනි දෑ අඩුවෙන් පෙන්වන්න",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Spam හෝ inbox එකෙහි ඇති Promotions folder වලට emails අත්වැරදීමකින් හෝ ළඟා වන්නේ ද යන්න සහතික කරගන්න. එසේ වන්නේ නම්, \"Mark as not spam\" සහ/හෝ \"Move to inbox\" යන්නෙහි click කරන්න.",
    "Manage": "කළමනාකරණය කරන්න",
    "Maybe later": "සමහර විට පසුව",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "සාමාජිකත්වයන් නොමැත, ප්\u200dරවේශය සඳහා වෙබ් අඩ\u200bවි හිමිකරු සම්බන්ධ කරගන්\u200bන.",
    "month": "",
    "Monthly": "මාසිකව",
    "More like this": "මෙවැනි දෑ වැඩියෙන් පෙන්වන්න",
    "More options": "",
    "Name": "නම",
    "Need more help? Contact support": "තවදුරටත් සහාය අවශ්\u200dයයි ද? සහායක සේවාව සම්බන්ධ කරගන්න",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "ඔබගේ ගිණුමෙහි newsletters අක්\u200dරීය වීමට හේතු දෙකක් දැක්විය හැකිය: පෙර යවන ලද email එකක් spam ලෙස සටහන් කිරීම, හෝ email එකක් යැවීමට උත්සාහ කිරීමේදී permenent faulure (bounce) එකක් වීමක් වාර්ථා වීම.",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Emails ලැබෙන්නේ නැද්ද?",
    "Now check your email!": "දැන් ඔබගේ email එක පරික්ෂා කරන්න!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "නැවත subscribe කළ විටත් ඔබගේ inbox එකට email ලැබෙන්නේ නැතිනම්, spam folder එක පරීක්ෂා කරන්න. ඇතැම් සේවා සපයන්නන් මීට පෙර spam සම්බන්ධව ලැබුණු පැමිණිලි පාදක කරගෙන තවදුරටත් emails spam ලෙස ලකුණු කරනු ලබනවා. එසේ වී ඇත්නම්,  අලුතින්ම ලැබුණු newsletter එක ඔබගේ primary inbox එකට යැවීමට 'Not spam' ලෙස සළකුනු කරන්න.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Permanent failure (bounce) එකක්",
    "Phone number": "",
    "Plan": "Plan එක",
    "Plan checkout was cancelled.": "Plan එක checkout කිරීම අවලංගු කරන ලදී.",
    "Plan upgrade was cancelled.": "Plan එක upgrade කිරීම අවලංගු කරන ලදී.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "කරුණාකර required files පිරවීමට කටයුතු කරන්න",
    "Podcasts": "",
    "Re-enable emails": "ඉමේල් නැවත සක්\u200dරීය කරන්න",
    "Recommendations": "නිර්දේශි\u200bත",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price} ක මුදලකට renew වනු ඇත.",
    "Resume subscription": "",
    "Retry": "නැවත උත්සහකරන්න",
    "Save": "Save කරන්න",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Login link එක යවමින්...",
    "Sending...": "යවමින්...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "සියල්ල පෙන්වන්\u200bන",
    "Sign in": "Sign in වෙන්න",
    "Sign out": "Sign out වෙන්න",
    "Sign up": "ලියාපදිංචි වෙන්න",
    "Signup error: Invalid link": "Signup වීම අසාර්ථකයි: වැරදි link එකකි",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "සමාවෙන්න, නමුත් එය සාර්ථක වූයේ නැත.",
    "Spam complaints": "Spam සඳහා වන පැමිණිලි",
    "Start {amount}-day free trial": "{amount}-day free trial එක ආරම්භකරන්න",
    "Starting {startDate}": "{startDate} සිට ආරම්භ වෙයි",
    "Starting today": "අද සිට ආරම්භ වෙයි",
    "Submit feedback": "ප්\u200dරතිචාරය යොමුකරන්න",
    "Subscribe": "Subscribe කරන්න",
    "Subscribed": "Subscribe කරන ලදී",
    "Subscription plan updated successfully": "",
    "Success": "සාර්ථකයි",
    "Success! Check your email for magic link to sign-in.": "සාර්ථකයි! sign-in වීමේ magic link එක සඳහා ඔබ\u200dෙගේ emails පරීක්ෂා කරන්න.",
    "Success! Your account is fully activated, you now have access to all content.": "සාර්ථකයි! ඔබගේ ගිණුම සම්පූර්ණයෙන්ම activate කර ඇති අතර, දැන් ඔබට සියළුම content සඳහා access ලැබී තිබෙනවා.",
    "Success! Your email is updated.": "සාර්ථකයි! ඔබගේ email ලිපිනය update කරන ලදී.",
    "Successfully unsubscribed": "සාර්ථකව unsubscribed කර ඇත",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "subscribe කිරී\u200bම ගැන ඔබට ස්තුතියි. ඔබ කියවීම ආරම්භ කිරීමට පෙර, ඔබට රසවිඳිය හැකි තවත් වෙබ් අඩවි කිහිපයක් පහත දැක්වේ.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "ප්\u200dරතිචාරය සඳහා ස්තූතියි!",
    "That didn't go to plan": "එය සැලැස්මට අනුකූලව සිදු වුණේ නෑ",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "ඔබගේ email ලිපිනය ලෙස අප සතුව තිබෙන්නේ {memberEmail} යන email ලිපිනයයි - මෙය වැරදියි නම්, ඔබගේ <button>account settings area එක</button> හරහා update කළ හැක.",
    "There was a problem submitting your feedback. Please try again a little later.": "ඔබගේ feedback එක යොමු කිරීමේදී ගැටළුවක් ඇති විය. තව ටික වේලාවකින් නැවත උත්සාහ කරන්න.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "මෙම වෙබ් අඩවිය ආරාධිතයන් සඳහා පමණි, ප්\u200dරවේශ වීම සඳහා හිමිකරු අමතන්න.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Signup වීම සම්පූර්ණ කිරීම සඳහා, ඔබ\u200dගේ inbox එකට ලැබුණු email එකෙහි ඇති confirmation link එක click කරන්න. එය මිනිත්තු 3ක් ඇතුලත නොපැමිණියේ නම්, spam folder එක පරීක්ෂා කරන්න!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "දින {amount}ක් නොමිලයේ භාවිතා කරන්න, ඉන් පසුව {originalPrice}ක් පමණි.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Paid subscriber කෙනෙකු වීම හරහා සියළුම newsletters වලට access ලබාගන්න.",
    "Unsubscribe from all emails": "සියළුම email වලින් unsubscribe කරන්න",
    "Unsubscribed": "Unsubscribe කරන ලදී",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Email වලින් unsubscribe වීමෙන්, {title} සඳහා වන ඔබගේ paid subscription එක අවලංගු නොවනු ඇත",
    "Update": "Update කරන්න",
    "Update your preferences": "ඔබගේ  preferences update කරන්න",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "ඔබගේ email ලිපිනය නිවැරදි බව තහවුරු කරන්න",
    "Verifying...": "",
    "View plans": "Plans පෙන්වන්න",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "ඔබගේ email ලිපිනය හමු නොවීම නිසාවෙන් ඔබව unsubscribe කරවීමට නොහැකි විය. කරුණාකර වෙබ් අඩවියෙහි හිමිකරු සම්බන්ධ කරගන්න.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "{name}, ඔබව සාදරයෙන් පිළිගන්නවා!",
    "Welcome back!": "ඔබව සාදරයෙන් පිළිගන්නවා!",
    "Welcome to {siteTitle}": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "යම් අවස්ථාවකදී email එකක් අදාල email ලිපිනයට ලබාගත නොහැකි නම්, එය පොදුවේ bounce ලෙස හඳුන්වනු ලබනවා. මෙය තාවකාලික තත්ත්වයක් විය හැකයි. කෙසේ නමුත්, ඇතැම් අවස්ථා වලදී අදාල email ලිපිනය වැරදි නම් හෝ එවැනි email ලිපිනයක් නොමැති නම්, bounce email එකක් permanent failure එකක් ලෙස නැවත හරවා යවනු ලැබෙනවා.",
    "Why has my email been disabled?": "මගේ emails අක්\u200dරීය කර ඇත්තේ ඇයි?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "වාර්ෂිකව",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "ඔබ සතුව දැනට ඇත්තේ free membership එකකි. සම්පූර්ණ access ලබාගැනීම සඳහා එය Paid membership එකකට upgrade කරන්න.",
    "You have been successfully resubscribed": "ඔබ සාර්ථකව නැවත subscribe කර ඇත",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "මේ වන විට ඔබට email ලැබෙන්නේ නැත",
    "You're not receiving emails": "ඔබට email ලැබෙන්නේ නැත",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "මෑතකදී ලැබුණු email පණිවිඩයක් spam ලෙස සටහන් කිරීම නිසා හෝ ඔබ ලබාදී ඇති email ලිපිනයට email පණිවිඩ යැවිය නොහැකි නිසාවෙන් ඔබට email ලැබෙන්නේ නැත.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "ඔබ සාර්ථකව sign in වන ලදී.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "ඔබ සාර්ථකව subscribe ක\u200bර ඇත <strong>{siteTitle}</strong>",
    "Your account": "ඔබගේ ගිණුම",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "ඔබගේ අදහස් ඉදිරියේදී සිදු කරන පළකිරීම් වැඩිදියුණු කිරීමට උදව් කරනු ඇත.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "ඔබගේ subscription එක {expiryDate} වැනි දින කල් ඉකුත් වනු ඇත",
    "Your subscription will renew on {renewalDate}": "ඔබගේ subscription එක {renewalDate} වැනි දින renew වනු ඇත",
    "Your subscription will start on {subscriptionStart}": "ඔබගේ subscription එක {subscriptionStart} වැනි දින ආරම්භ වනු ඇත"
}
